const toIdentifierList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

export const getMetricAreaIdentifiers = (dataset, metric) => {
  const pluralMetric = metric.endsWith('s') ? metric : `${metric}s`;
  const metricIdentifiers = toIdentifierList(
    dataset?.[`${metric}AreaIdentifiers`] ?? dataset?.[`${pluralMetric}AreaIdentifiers`] ?? dataset?.[`${metric}DatasetKeys`] ?? dataset?.[`${pluralMetric}DatasetKeys`]
  );
  if (metricIdentifiers.length) return metricIdentifiers;

  const sharedIdentifiers = toIdentifierList(dataset?.areaIdentifiers);
  if (sharedIdentifiers.length) return sharedIdentifiers;

  return toIdentifierList(dataset?.areaIdentifier ?? dataset?.key);
};

export const getEfficiencyAreaIdentifiers = (dataset) => getMetricAreaIdentifiers(dataset, 'efficiency');
export const getErrorAreaIdentifiers = (dataset) => getMetricAreaIdentifiers(dataset, 'error');
export const getDoubleAreaIdentifiers = (dataset) => getMetricAreaIdentifiers(dataset, 'double');

export const getAllStatisticsAreaIdentifiers = (datasets) => [
  ...new Set((datasets ?? []).flatMap((dataset) => [...getEfficiencyAreaIdentifiers(dataset), ...getErrorAreaIdentifiers(dataset), ...getDoubleAreaIdentifiers(dataset)]))
];
